<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-show="showList">
      <b-col lg="10">
        <b-card >
          <div slot="header">Consolidation Member 
            <div class="card-header-actions">
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
      <b-row >
        <b-col lg="8">
          <b-input-group>
            <b-input-group-prepend><span class="pt-2 pr-2">Holding Company</span></b-input-group-prepend>
            <b-form-input v-model="user.company" readonly></b-form-input>
            <div class="text-muted" style="font-size:smaller; width:180px;">perusahaan yang menyusun laporan konsolidasi</div>
            <b-button class="btn btn-primary ml-2" @click="add()" > <i class="fa fa-plus"></i> Add Member</b-button>
          </b-input-group>
        </b-col>
      </b-row>

        <b-table
            class="mb-0"
            ref="tblConsol"
            outlined  responsive hover small
            :items="getData"
            :fields="tblFields"
            :per-page="20"
            @row-clicked="rowClicked"
          >
              <template v-slot:cell(nomor)="data">
                {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
              </template>
              <template v-slot:cell(company)="data">
                {{data.item.company}} <span v-if="(data.item.consolidated==1)" style="background-color:yellow;">(CONSOLIDATED)</span>
              </template>

              <template v-slot:cell(holding)="data">
                <span v-if="(data.item.holding)" style="font-weight:bolder ">Holding</span>
                <span v-else>Unit</span>
              </template>
              <template v-slot:cell(sahamholding)="data">
                {{ data.item.sahamholding }} %
              </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
                  <i class="fa fa-trash"></i>
                </a>
              </div>

            </template>
        </b-table>

        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8" lg="7">
        <b-card >
          <div slot="header">Add/Edit Consolidation Member  
            <div class="card-header-actions">
              <b-button variant="primary" @click="closeFrm()" > <i class="fa fa-close"></i> Close</b-button>
            </div>
          </div>
                  <b-input-group>
                      <b-input-group-prepend ><label >Data Source</label></b-input-group-prepend>
                      <b-form-radio-group  class="mt-2" v-model="frmdata.erpsource" >
                          <b-form-radio value="1">EkosSystem ERP</b-form-radio>
                          <b-form-radio value="0">Manual Import/Upload Excel File</b-form-radio>
                      </b-form-radio-group>
                  </b-input-group>          
                    <b-input-group >
                        <b-input-group-prepend><label>Company Name</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.company" :state="!$v.frmdata.company.$error" ></b-form-input>
                        <b-input-group-append v-if="(frmdata.erpsource==1)">
                        <b-btn text="Button" @click="lkuCompanyShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                              <b-form-checkbox  class="ml-3 mt-2" v-model="frmdata.consolidated" value=1 unchecked-value=0 >Consolidated</b-form-checkbox>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>NPWP Name</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.npwp_name" :state="!$v.frmdata.npwp_name.$error" :disabled="(frmdata.erpsource==1)"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>NPWP Address</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.npwp_address" :state="!$v.frmdata.npwp_address.$error" :disabled="(frmdata.erpsource==1)"></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col lg="6">
                          <b-input-group >
                              <b-input-group-prepend><label>Share Holding</label></b-input-group-prepend>
                              <b-form-input v-model="frmdata.sahamholding"  type="number" :state="!$v.frmdata.sahamholding.$error" :disabled="(frmdata.holding==1)"></b-form-input>
                              <b-input-group-append> <span class="input-group-text"><i class="fa fa-percent"></i></span></b-input-group-append>
                              <b-form-checkbox  class="ml-3 mt-2" v-model="frmdata.holding" value=1 unchecked-value=0 :disabled="(frmdata.compcode!=user.compcode)">Holding Company</b-form-checkbox>
                          </b-input-group>

                        </b-col>
                    </b-row>
          <div style="text-align:center;" class="mt-2">
            <button class="btn btn-primary mr-1" @click="save()" v-if="saveEnabled">
              <i class="fa fa-save"></i> Save
            </button>
            <button class="btn btn-danger mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
          </div>
        </b-card>        
      </b-col>
    </b-row>
        <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="Consolidation Company" :centered="true">
            <lku-company @click="onSelectLkuCompany"></lku-company>
        </b-modal>        

  </div>
</template>


<script>
import toastr from "mini-toastr";
import lkuCompany from "../lookup/lkuCompany"
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components:{lkuCompany},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        compcode: { required },
        sahamholding: { required },
        company : 		{ required },
        npwp_name: { required },
        npwp_address : 		{ required },
        // npwp_name: {required : (function() {
        //     if (this.frmdata.erpsource==1) {
        //         return true;
        //     } else if (!(this.frmdata.npwp_name)){
        //         return false;
        //     } else return true;
        // })},
        // npwp_address: {required : (function() {
        //     if (this.frmdata.erpsource==1) {
        //         return true;
        //     } else if (!(this.frmdata.npwp_address)){
        //         return false;
        //     } else return true;
        // })},
    },
  }, 
  data() {
    return {
      showList: true,
      showForm: false,
      lkuCompanyShow: false,
      saveEnabled: true,
      user: this.$store.state.user,
      frmdata:{
        compcode: '', 
        consolidated: 0,
        sahamholding: 51, 
        holding:0,
        erpsource:1,
        company : '',
        npwp_name : '',
        npwp_address : ''
      },
      tblData: {
        tablename:'consolidation-member',
        page: 1,
        total: 0,
        limit:10,
        sortBy: 'sahamholding',
        sortDesc: true
      },
      tblFields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "company",
            label: "Company Brand Name",
            sortable: true
          },
          {
            key: "npwp_name",
            label: "NPWP Name",
            sortable: true
          },
          {
            key: "npwp_adress",
            label: "Address",
          },
          {
            key: "holding",
            label: "Status",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "sahamholding",
            label: "Share Holding",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
      ],
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },  
  watch: {
    "frmdata.holding": function(newVal) {
      setTimeout(() => {
        if (this.frmdata.holding==1) {
            this.frmdata.sahamholding=100;
        }
      }, 100);
    }
  },  
  methods: {
    onSelectLkuCompany: async function (_selected) {
            this.frmdata.compcode= _selected.compcode;
            this.frmdata.company= _selected.company;
            this.frmdata.consolidate= _selected.holding;
            this.frmdata.npwp_name = _selected.npwp_name || _selected.company;
            this.frmdata.npwp_address = _selected.npwp_address;

          if (this.frmdata.compcode==this.user.compcode) {
              this.frmdata.holding= 1;
              this.frmdata.sahamholding=100;
            }
          this.lkuCompanyShow=false;
    },  
    getData: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery = 'holdingcode=' + encodeURIComponent(this.user.compcode);
      console.log(this.tblData.customQuery);
      const list = await crud.list(this.tblData);    
      // console.log(list) ;
      this.list=list; 
      return this.list;
    },
    refresh(ctx) {
      if (this.$refs.tblConsol) this.$refs.tblConsol.refresh();
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
        this.showForm=true;
        this.showList=false;
        this.isEdit=true;
    },
    add: async function() {
      this.frmdata.holdingcode= this.user.compcode
      this.frmdata.memberkey='';
      this.frmdata.compcode='';
      this.frmdata.company='';
      this.frmdata.npwp_name='';
      this.frmdata.npwp_address='';
      this.frmdata.consolidated=0;
      this.frmdata.holding=0;
      this.frmdata.sahamholding='51';
      this.frmdata.erpsource=1;

        this.showForm=true;
        this.showList=false;
        this.isEdit=true;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
          await crud.remove({tablename:'consolidation-member', key:this.model.memberkey});
          this.refresh();
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }

    },    
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;             
        if (this.invalidFrmdata) {
            const invalidobj={};
            for (var key in this.$v.frmdata) {
              if (this.$v.frmdata[key].$anyError) {
                if (this.$v.frmdata[key].$anyError==true) invalidobj[key] = this.$v.frmdata[key];
              }
            }        
            console.log('validation frmdata: ', this.$v.frmdata);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;             
        } else {
            try {
              const data = {};
                if (this.frmdata.erpsource!=1) {
                    data.compcode  =  this.frmdata.company.replace(/[\W_]+/g,"").substr(0,50); 
                    //replace all non Alpha Numeric characters, New Lines, and multiple Whitespace
                } else {
                  data.compcode  =  	 this.frmdata.compcode ;
                }
                data.holdingcode  =  	 this.user.compcode; 
                data.company  =  	 this.frmdata.company ; 
                data.npwp_name  =  	 this.frmdata.npwp_name; 
                data.npwp_address  =  	 this.frmdata.npwp_address; 
                data.consolidated = this.frmdata.consolidated;
                data.holding  =  	 this.frmdata.holding; 
                data.sahamholding  =  	 this.frmdata.sahamholding; 
                data.erpsource  =  	 this.frmdata.erpsource; 

                if (this.frmdata.memberkey){
                    if (this.frmdata.erpsource==1){
                        await Promise.all([crud.update({tablename:'consolidation-member', key:this.frmdata.memberkey, data}),
                            crud.update({tablename:'company', key:this.frmdata.compcode,data: {npwp_name: this.frmdata.npwp_name, npwp_address: this.frmdata.npwp_address}})]);
                    } else {
                      await crud.update({tablename:'consolidation-member', key:this.frmdata.memberkey, data});
                    }

                } else {
                    await crud.insert({ tablename:'consolidation-member', data});

                }
                toastr.success("Company Consolidation Saved");   
                this.refresh();             
                this.closeFrm()
                this.saveEnabled=true;             
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Company Consolidation Error");   
                this.saveEnabled=true;             
            }
        }
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
